import ApiRequest from '../../api/request';
import { SchemaField } from '../../types';
import { FormInputType } from './Form.types';

async function schemaFieldToFormInput(schemaField: SchemaField, token?: string) {
  // If type is in this array then make it a select validation
  const selectTypes = ['reference', 'select'];
  if (schemaField.name !== 'isDeleted' && schemaField.name !== 'createdBy') {
    const type = schemaField.type
      .replace('string', 'text')
      .replace('secure', 'password')
      .replace('reference', 'select');
    let options = null;
    let element = 'input';
    if ((type === 'string' && schemaField.maxLength < 48) || type === 'secure' || type === 'file') {
      element = 'input';
    } else if (type === 'string' && schemaField.maxLength >= 48) {
      element = 'textarea';
    } else if (type === 'select') {
      element = 'select';
      // Garbage: ~~If its an array the field name is most likely plural so lets parse out the last s~~
      const modelname = schemaField.reference;
      /* if(schemaField.isArray)
      {
        if(schemaField.name.charAt(schemaField.name.length - 1) === 's')
        {
          modelname = schemaField.name.substr(0, schemaField.name.lastIndexOf('s'));
        }
      } */
      // If values provided in schema field build list out of that
      if (schemaField.values && schemaField.values.length > 0) {
        options = schemaField.values.split(',').map(value => ({ text: value, value }));
      } // Need to query model documents and build option list
      // Backend will handle validating permissions if we can query or not
      else {
        const params = { model: modelname, params: {} };
        const response = await ApiRequest.sendRequest({
          method: 'post',
          params,
          path: 'data/query',
          token,
        });

        if (response.data.error !== null) {
          return { error: response.data.error, model: modelname };
        }

        // Build option list
        options = response.data.results.map((ptr: SchemaField) =>
          // @ts-ignore
          ({ text: ptr[schemaField.keyInReference], value: ptr._id }),
        );
      }
    } else if (type === 'boolean') {
      element = 'select';
      options = [
        { text: 'True', value: 'true' },
        { text: 'False', value: 'false' },
      ];
    } else if (type === 'space') {
      element = 'space';
    } else if (type === 'datetime') {
      element = 'datetime';
    } else if (type === 'date') {
      element = 'date';
    }

    let validation: any = {};
    if (schemaField.required) {
      let requirement = `A ${schemaField.name} is required`;
      if (schemaField.name?.indexOf('_confirm_') !== -1) {
        requirement = `Confirming ${schemaField.name?.replace('_confirm_', '')} is required`;
      }
      validation = {
        requirement,
        algorithm: selectTypes.indexOf(schemaField.type) !== -1 ? 'select' : 'range',
        min: schemaField.type === 'boolean' ? 0 : schemaField.minLength,
        max: schemaField.type === 'boolean' ? 9 : schemaField.maxLength,
      };
    }

    const formInput: FormInputType = {
      // label: schemaField.name,
      id: schemaField.name ?? '',
      element,
      // @ts-ignore
      type,
      required: schemaField.required ? 'required' : '',
      value: '',
      multiSelectEnabled: schemaField.isArray,
      placeholder: schemaField.placeholder,
      tooltip: schemaField.tooltip,
      tooltipQuestion: schemaField.tooltipQuestion,
      label: '',
      rowClassName: '',
    };
    if (['select', 'boolean'].includes(formInput.type) && options) {
      formInput.options = options;
      formInput.reference = schemaField.reference;
      formInput.key = schemaField.keyInReference;
      // console.log(formInput);
    }
    // @ts-ignore
    if (formInput.type !== 'file' && formInput.type !== 'space') {
      formInput.validation = validation;
      if (!schemaField.placeholder) {
        if (schemaField.name) {
          const words = schemaField.name.split(/(?=[A-Z])/);
          formInput.placeholder = 'Enter';
          for (let i = 0; i < words.length; i++) {
            formInput.placeholder += ` ${words[i].toLowerCase()}`;
          }
        }
      }
    }
    // @ts-ignore
    if (formInput.type === 'link') {
      formInput.to = schemaField.to;
      formInput.text = schemaField.text;
    } else if (formInput.type === 'button') {
      // @ts-ignore
      formInput.route = schemaField.route;
      // @ts-ignore
      formInput.successActions = schemaField.successActions;
      // @ts-ignore
      formInput.title = schemaField.title;
      // @ts-ignore
      formInput.isDisabled = schemaField.disabled;
      // formInput.disabled = true;
    }
    if ((schemaField.row || schemaField.row === 0) && (schemaField.col || schemaField.col === 0)) {
      formInput.row = schemaField.row;
      formInput.col = schemaField.col;
    }
    // @ts-ignore
    if (formInput.type === '_form_footer_') {
      // @ts-ignore
      formInput.title = schemaField.title;
    }

    // Only put label on form if it's actually there
    if (schemaField.label && schemaField.label.length > 0) {
      formInput.label = schemaField.label;
    }

    return formInput;
  }
  return null;
}

function getSelectedFiles(input: any) {
  if (input.hasAttribute('multiple')) {
    return (
      [].slice
        .call(input.files)
        // @ts-ignore
        .map(file => file.name)
        .join(', ')
    );
  }

  if (input.value.indexOf('fakepath') !== -1) {
    const splittedValue = input.value.split('\\');
    return splittedValue[splittedValue.length - 1];
  }

  return input.value;
}

function extractValueFromPointer(iFieldName: string, iRow: any) {
  // console.log(iFieldName);

  let fieldName = iFieldName;
  let fieldNameInPtr = '';
  let row = iRow;

  // Get total pointers in key
  const occurrences = (fieldName.match(/\./g) || []).length;
  if (occurrences === 0) {
    return iRow[iFieldName];
  }

  // Iterate all pointers
  let splitIndex = -1;
  for (let i = 0; i < occurrences; i++) {
    splitIndex = fieldName.indexOf('.');
    try {
      // Extract pointer
      fieldNameInPtr = fieldName.substring(splitIndex + 1);
      fieldName = fieldName.substring(0, splitIndex);

      // Slowly parse down the data
      if (fieldNameInPtr.indexOf('.') !== -1) {
        row = row[fieldName];
      } else {
        return row[fieldName][fieldNameInPtr];
      }
      fieldName = fieldNameInPtr;
    } catch (err) {
      console.log(`Pointer: ${fieldNameInPtr} not found in property ${fieldName}`);
      return '';
    }
  }
}
export { extractValueFromPointer, schemaFieldToFormInput, getSelectedFiles };
